import firebase from 'firebase/app';
import 'firebase/firestore';

// import pageObj from '@/assets/data/portoObj';

const config = {
  apiKey: 'AIzaSyAE03PZ2ymt1J_CVa2izVSo5EIY--4-qsY',
  authDomain: 'owof-eedb8.firebaseapp.com',
  databaseURL: 'https://owof-eedb8.firebaseio.com',
  projectId: 'owof-eedb8',
};

firebase.initializeApp(config);
export const db = firebase.firestore();

// db.collection('cities').doc('porto').collection('data').doc('porto')
//   .set(pageObj)
//   .then(() => {
//     console.log('Document successfully written!');
//   });
// db.collection('cities').doc('paris').delete();
// db.collection('about').doc('content')
//   .set(pageObj)
//   .then(() => {
//     console.log('Document successfully written!');
//   });
export default db;



// WEBPACK FOOTER //
// ./src/store/create-api.js